// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"113":"plan-simulator","272":"dashboard-admin"}[chunkId] + ".js?id=" + {"113":"79cfd51cda44ac10","272":"4290df92fd59a85a"}[chunkId] + "";
};